<template>
    <div style="z-index:0;position:relative;width:100%;height:100%;margin-left:0;background: rgb(154,255,186);
background: linear-gradient(40deg, rgba(164, 65, 248, 0.72) 0%, rgb(47, 218, 158) 100%);">
        <video id="video_flare2"  muted="" loop autoplay class="fullscreen-bg__video" style="pointer-events: none;z-index: -1;">
            <source :src="require('../assets/white_flare.webm')" type="video/webm">

        </video>
        <video id="video_greet" loop="" muted="" autoplay="" class="fullscreen" style="opacity: 0.2;pointer-events: none;z-index: -1;">">
            <source :src="video_source">
        </video>
        <v-row
                align="center"


                class="mx-12"
                style="height:80vh;margin-top:2vh;z-index: 100;position: relative;"
        >
            <v-col class="text-left" style="max-width:500px;background: rgba(129, 134, 169, 0.34); border-radius: 20px;padding:20px;" cols="12">
                <h1 class="display-3 font-weight-bold mb-3 text--uppercase" >Bjud in din publik</h1>

                <h2 class="font-weight-light" style="margin-top:40px;">Med <v-chip to="/donations" link style="background:rgba(255,255,255,0.2) !important;" class="white--text"><b>Donationer</b></v-chip>, <v-chip to="/streamhotel"  link style="background:rgba(255,255,255,0.2) !important;" class="white--text"><b>Stream Hotel</b></v-chip> och <v-chip to="/spons"  link style="background:rgba(255,255,255,0.2) !important;" class="white--text"><b>Spons</b></v-chip> tar du din stream till nästa nivå. </h2>

                <span>
                    <v-btn v-if="!$store.getters.loggedIn" block class="mx-auto my-12" x-large @click="letsgo" dark style="background: linear-gradient(40deg, rgb(106, 187, 187) 0%, rgb(47, 218, 158) 100%);" color="teal">Kom igång </v-btn>
                    <v-btn v-else-if="$store.getters.loggedIn" block class="mx-auto my-12" x-large @click="letsgome" dark style="background: linear-gradient(40deg, rgb(106, 187, 187) 0%, rgb(47, 218, 158) 100%);" color="teal">Min sida</v-btn>

                </span>


            </v-col>
        </v-row>
    </div>
</template>

<script>

    export default {
        name: "VideoGreet",
        data(){
            return{
                videos:["guthen.webm","ettnix.webm","fooogie.webm","yznb.webm","tottecsgo.webm","hicards.mp4"],
                videoIndex:0

            }
        },
        mounted:function(){
            this.videoIndex=Math.floor(Math.random()*this.videos.length);
            let self=this;
            setInterval(function(){
                let vid=$("#video_greet" );
                $(vid).animate({
                    opacity: 0.0
                }, 1000, function() {
                    self.videoIndex++;
                    document.getElementById("video_greet")?.load();
                    document.getElementById("video_greet")?.play();
                    $( vid ).animate({
                        opacity: 0.2},1000)
                });


            },8000)

        },
        computed:{
          video_source:function(){
              return '/api/images/reel_'+this.videos[this.videoIndex % this.videos.length]
          }
        },
        methods:{
            changeVideo:function(){

            },
            letsgo:function(){
                this.$store.state.APP.SHOW_LOGIN=true;
            },
            letsgome:function(){
                this.$router.push({ path: `/${this.$store.state.STYLE.PATH}` })

            }
    }
    }
</script>

<style scoped>
    .fullscreen{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-size:cover;
        margin:0 !important;
        object-fit: cover;
        padding:0 !important;
        z-index:0 !important;
        pointer-events: none;
    }
</style>
